// input 31000
// en-US 31,000
// en-GB 31,000
// en-CA 31,000
export function formatNumber(value: number, options: Intl.NumberFormatOptions | undefined, locale: string) {
    return value.toLocaleString(locale, options);
}
